export function jsonToFormData(
  data: Record<string, any>,
  form?: FormData,
  parentKey?: string,
): FormData {
  const formData = form || new FormData();

  Object.entries(data).forEach(([key, value]) => {
    const fieldKey = parentKey ? `${parentKey}[${key}]` : key;

    if (value instanceof File || value instanceof Blob) {
      // file, blob
      formData.append(fieldKey, value);
    } else if (Array.isArray(value)) {
      // Check if this is an array of files/blobs
      if (
        value.length > 0 &&
        (value[0] instanceof File || value[0] instanceof Blob)
      ) {
        // For file arrays, append each file with the same key
        value.forEach((item) => {
          formData.append(fieldKey, item);
        });
      } else {
        // For other arrays, use the index notation
        value.forEach((item, index) => {
          jsonToFormData({ [index]: item }, formData, fieldKey);
        });
      }
    } else if (value !== null && typeof value === "object") {
      // nested object
      jsonToFormData(value, formData, fieldKey);
    } else if (value !== undefined) {
      // primitive
      formData.append(fieldKey, String(value));
    }
  });

  return formData;
}
